import { usePagePrefs } from "./PagePrefs";
import { useSortByTeam } from "./SortByTeamContext";

// Favourite = the league-wide team sort (team_default). Setting it ONCE replaces
// every per-page sort for that league (clears page_team pins); a desktop
// shift+click then overrides it for a single page.
// Values: PWHL team id | NHL abbr | "conf:<name>" | "div:<name>" | null.
// "multi:a,b,c" = several teams (shift+click).
export const multiOf = (val) => (val && val.startsWith("multi:") ? val.slice(6).split(",").filter(Boolean) : val && !val.includes(":") && val !== "all" ? [val] : []);
export const toggleMultiVal = (val, id) => {
    const cur = multiOf(val);
    const next = cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id];
    return next.length > 1 ? `multi:${next.join(",")}` : (next[0] || null);
};
export const applySurf = (sb, lg, val) => {
    const v = val && val !== "all" ? val : null;
    if (v && v.startsWith("multi:")) { sb.setSurfMulti(lg, multiOf(v)); return; }
    sb.setSurfMulti(lg, []);   // a single/group/All target must drop any multi pick from the last page
    if (lg === "nhl") {
        if (v && v.startsWith("conf:")) { sb.setNhlSurfGroup(v.slice(5)); sb.setNhlSurfTeam(null); }
        else if (v && v.startsWith("div:")) { sb.setNhlSurfGroup(v.slice(4)); sb.setNhlSurfTeam(null); }
        else { sb.setNhlSurfTeam(v); sb.setNhlSurfGroup(null); }
    } else if (v && v.startsWith("conf:")) {
        sb.setSurfTeam(null); sb.setPwhlSurfGroup(v.slice(5));
    } else {
        sb.setPwhlSurfGroup(null); sb.setSurfTeam(v);
    }
};

export function useFavourite() {
    const { prefs, getPref, persist } = usePagePrefs();
    const sb = useSortByTeam();
    const getFavourite = (lg) => getPref("team_default", lg) || null;
    const setFavourite = (lg, val) => {
        const isNhlRoute = (r) => r.startsWith("/nhl");
        const page_team = Object.fromEntries(Object.entries(prefs.page_team || {}).filter(([r]) => (lg === "nhl") !== isNhlRoute(r)));
        const team_default = { ...(prefs.team_default || {}) };
        if (val) team_default[lg] = val; else delete team_default[lg];
        persist({ ...prefs, team_default, page_team });
        if (lg === "international") return;   // country favourites only colour/order the INT schedule
        applySurf(sb, lg, val);   // page sort only — Account favourite teams are a separate setting
    };
    return { getFavourite, setFavourite };
}

// Pages where the league favourite auto-applies (team pages): Standings, Rosters, Lineups.
export const isFavPage = (path = "") => /^\/(nhl\/|pwhl\/)?(standings|rosters|active-lineup|lineups)(\/|$)/.test(path);
